import React from "react";
import BlockStyleButton from "./BlockStyleButton";
import HeaderStyleDropdown from "./HeaderStyleDropdown";
import {css} from "@emotion/css";

export const BLOCK_TYPES = [
    // {label: " “ ” ", style: "blockquote", icon: "text-link-icon"},
    {label: "UL", style: "unordered-list-item", icon: "bullets-link-icon"},
    {label: "OL", style: "ordered-list-item", icon: "numbering-link-icon"},
    // {label: "{ }", style: "code-block", icon: "text-link-icon"}
];

export const HEADER_TYPES = [
    {label: "(None)", style: "unstyled"},
    {label: "H1", style: "header-one"},
    {label: "H2", style: "header-two"},
    {label: "H3", style: "header-three"},
    {label: "H4", style: "header-four"},
    {label: "H5", style: "header-five"},
    {label: "H6", style: "header-six"}
];

export function getBlockStyle(block) {
    switch (block.getType()) {
        case "blockquote":
            return "RichEditor-blockquote";
        default:
            return null;
    }
}

const BlockStyleToolbar = (props) => {

    const {editorState} = props;
    const selection = editorState.getSelection();
    const blockType = editorState
        .getCurrentContent()
        .getBlockForKey(selection.getStartKey())
        .getType();


    return (
        <span className={`${css`
          display: flex;
          flex-direction: row;
          gap: 1rem;`}`}>
				<HeaderStyleDropdown
                    headerOptions={HEADER_TYPES}
                    active={blockType}
                    onToggle={props.onToggle}
                />

            {BLOCK_TYPES.map(type => {
                return (
                    <BlockStyleButton
                        active={type.style === blockType}
                        label={type.label}
                        onToggle={props.onToggle}
                        style={type.style}
                        key={type.label}
                        type={type}
                        icon={type.icon}
                    />
                );
            })}
			</span>
    )
}

export default BlockStyleToolbar;